﻿window.lstTypeTraitement = [
    //{
    //nom_type_traitement: "suppressionbaseclient",
    //title_jauge: "Suppression d'un espace client"
    //},
    {
        nom_type_traitement: "recalculadressepostale",
        title_jauge: "Recalcul d'adresse postale"
        //lst de :
        //{ 
        //  id_histo: ligne.id,
        //  id_table: ligne.id_table_element,
        //  id: ligne.id_element
        //}
    },
    {
        nom_type_traitement: "restaurationcorbeille",
        title_jauge: "Restauration de la corbeille"
        //lst de :
        //{ 
        //  id_histo: ligne.id,
        //  id_table: ligne.id_table_element,
        //  id: ligne.id_element
        //}
    },
    {
        nom_type_traitement: "deletedefinitivementfromhistorique",
        title_jauge: "Suppression défintive à partir de la corbeille"
        //lst de :
        //{ 
        //  id_histo: ligne.id,
        //  id_table: ligne.id_table_element,
        //  id: ligne.id_element
        //}
    },
    //{
    //nom_type_traitement: "creationbaseclient",
    //title_jauge: "Création espace client"
    //},
    {
        nom_type_traitement: "deldanscorbeillelot",
        title_jauge: "Mise à la corbeille"
        //{
        //      id_table: ligne.id_table,
        //      id: ligne.id
        //}
    }, {
        nom_type_traitement: "importstrcon",
        title_jauge: "Importation de données"
        // data import de l'importstrcon
    }]

//option = {
//    command: "traitementbloquantsession",
//    nom_type_traitement: //null si on veut récupérer le traitement en cours
//    id_traitement_serveur: //null si on veut créer un traitement
//    cancel: "0",
//    fini: "0",
//    value: "0",
//    total: "1",
//    data: option.data //pour init d'un traitement
//}
window.hasTraitementBloquantEnCours = false
window.cTraitementBloquantSession = function (bddRef, dataToBeSent, option) {
    var Me = this;
    //var nomTypeTraitement = option.nom_type_traitement
    //var idTraitementServeur = null
    //var title = lstTypeTraitement.filter(function (o) { return o.nom_type_traitement == nomTypeTraitement })[0].title

    if (dataToBeSent == null) {
        dataToBeSent = { command: "traitementbloquantsession" }
    } else { dataToBeSent.command = "traitementbloquantsession" }

    function mExecute() {
        var timeoutCall = null;
        var ReqAjax = null;

        if (typeof dataToBeSent.nom_type_traitement != 'undefined' && dataToBeSent.nom_type_traitement != "verification_email") {
            //on init un traitement (nouveau ou en cours)
            var title = lstTypeTraitement.filter(function (o) { return o.nom_type_traitement == dataToBeSent.nom_type_traitement })[0].title
            title += "<div style='font-size:80%;line-height:1;'>Le traitement se déroule en arrière-plan.<br/>Vous pouvez quitter l’application sans interrompre sa progression</div>"
            jaugeDemarrage.$DivTitle.html(title)
            jaugeDemarrage.mShow()
            hasTraitementBloquantEnCours = true

            //jaugeDemarrage.option("onCancel", function (e) {
            //    mCancelInterne(e)
            //})
        }

        function mCancelInterne(e) {
            e.component.option("disabled", true);
            window.clearTimeout(timeoutCall);
            if (ReqAjax) ReqAjax.abort();
            dataToBeSent.cancel = "1"
            dataToBeSent.command = "traitementbloquantsession"
            bddRef.mAjaxCall(dataToBeSent, function (data) {
                mCancel()
            });
        }

        var func = function () {
            window.clearTimeout(timeoutCall)
            dataToBeSent.command = "traitementbloquantsession"
            ReqAjax = bddRef.mAjaxCall(dataToBeSent, function (data) {
                ReqAjax = null;
                if (typeof dataToBeSent.nom_type_traitement == 'undefined') {
                    //on a demandé à récupérer le traitement en cours s'il y en a un
                    if (typeof data.traitement != 'undefined' && typeof data.traitement.nom_type_traitement != 'undefined') {
                        //on a un traitement sur le serveur
                        //on le démarre
                        var traitBlock = new cTraitementBloquantSession(bddRef, data.traitement)
                        if (typeof option != 'undefined' && option.onDemarrage) mNotify("Vous avez un traitement en cours sur le serveur", "success", 6000)
                        hasTraitementBloquantEnCours = true
                    } else {
                        //on a pas de traitement
                    }
                } else {
                    //on a un traitement en cours
                    dataToBeSent = data.traitement

                    dataToBeSent.message += "<div style='font-size:80%;line-height:1;'>Le traitement se déroule en arrière-plan.<br/>Vous pouvez quitter l’application sans interrompre sa progression</div>"
                    if (dataToBeSent.nom_type_traitement == "importstrcon") {
                        dataToBeSent.message += "<div style='font-size:80%;line-height:1;'>Attention, l'importation peut bloquer le travail des autres utilisateurs.</div>"
                    }
                    jaugeDemarrage.mAvance(dataToBeSent.message, parseInt(dataToBeSent.position), parseInt(dataToBeSent.total))
                    if (dataToBeSent.allow_cancel == "True") {
                        jaugeDemarrage.option("onCancel", function (e) {
                            mCancelInterne(e)
                        })
                    } else {
                        jaugeDemarrage.option("onCancel", null)
                    }
                    switch (dataToBeSent.fini) {
                        case "0": //traitement en cours
                            timeoutCall = window.setTimeout(function () { func() }, 1500);
                            break;
                        case "1": //traitement fini sans erreur
                            mFinTraitementOk()
                            break;
                        case "-1": //traitement erreur
                            mFinTraitementErreur(data)
                            break;
                    }
                }
            }, function (data) {
            }, function (data) {
                //on a une erreur ajax
                //on continue
                timeoutCall = window.setTimeout(function () { func() }, 1500);
            })
        }
        func();
    }

    function mCancel(e) {
        switch (dataToBeSent.nom_type_traitement) {
            case "recalculadressepostale":
                mNotify("Vous avez annulé le recalcul d'adresse postale. Une partie des adresses n'a pas été recalculée.", "warning", 6000);
                mFinTraitementGeneral();
                break;
            case "restaurationcorbeille":
                mNotify("Vous avez annulé la restauration de données. Une partie des données n'a pas été restaurée.", "warning", 6000);
                mFinTraitementGeneral();
                break;
            case "deletedefinitivementfromhistorique":
                mNotify("Vous avez annulé la suppression définitive de données. Une partie des données n'a pas été supprimée.", "warning", 6000);
                mFinTraitementGeneral();
                break;
            case "deldanscorbeillelot":
                mNotify("Vous avez annulé la mise à la corbeille. Une partie des données n'a pas été mise à la corbeille.", "warning", 6000);
                mFinTraitementGeneral();
                break;
            case "importstrcon":
                mNotify("Vous avez annulé l'importation de données. Aucune données n'a été importées.", "warning", 6000);
                //mFinTraitementGeneral();
                jaugeDemarrage.mHide()
                break;
        }
        hasTraitementBloquantEnCours = false
    }
    function mFinTraitementErreur(data) {
        var txt = ""
        jaugeDemarrage.mHide()
        switch (dataToBeSent.nom_type_traitement) {
            case "recalculadressepostale":
                txt = "Une erreur s'est produite durant le calcul des adresses.<br/>Une partie des données n'a pas été recalculée."
                break;
            case "restaurationcorbeille":
                txt = "Une erreur s'est produite durant la restauration.<br/>Une partie des données n'a pas été restaurée."
                break;
            case "deletedefinitivementfromhistorique":
                txt = "Une erreur s'est produite durant la suppression.<br/>Une partie des données n'a pas été supprimée."
                break;
            case "deldanscorbeillelot":
                txt = "Une erreur s'est produite durant la mise à la corbeille.<br/>Une partie des données n'a pas été mise à la corbeille."
                break;
            case "importstrcon":
                txt = "L'application a rencontré un problème avec une partie de vos données à importer.<br/>Impossible d'exécuter l'importation."
                break;
        }
        if (data.traitement.erreur_message != null && data.traitement.erreur_message.length > 0) {
            txt = txt + "<br/><br/><div style='font-size:90%;font-style:italic;color:red;opacity:0.7;'>" + data.traitement.erreur_message + "</div>"
        }
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            height: "auto",
            showMaximize: false,
            showCloseButton: false,
            width: 400,
            contentTemplate: function (contentElement) {
                var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:80px;'><i class='fas fa triangle-exclamation' style='color:red;font-size:60px;'></i></td>").appendTo($Table)
                var $Td = $("<td style='width:100%'>" + txt + "</td>").appendTo($Table)
                $("<br/>").appendTo(contentElement)
                mAddButtonOkAnnuler(contentElement, null, function () { //non
                    popup.hide()
                }, "Ok")
            }
        }).dxCtrlPopupBase("instance")
        popup.show()

        switch (dataToBeSent.nom_type_traitement) {
            case "restaurationcorbeille": case "deletedefinitivementfromhistorique": case "deldanscorbeillelot":
                mFinTraitementGeneral();
                break;
            case "importstrcon":
                break;
        }
        hasTraitementBloquantEnCours = false
    }
    function mFinTraitementOk() {
        switch (dataToBeSent.nom_type_traitement) {
            case "recalculadressepostale":
                mNotify("Les adresses ont été recalculées.", "success", 6000)
                mFinTraitementGeneral();
                break;
            case "restaurationcorbeille":
                mNotify("Les données ont été restaurées.", "success", 6000)
                mFinTraitementGeneral();
                break;
            case "deletedefinitivementfromhistorique":
                mNotify("Les données ont été supprimées.", "success", 6000)
                mFinTraitementGeneral();
                break;
            case "deldanscorbeillelot":
                mNotify("Les données ont été mises à la corbeille.", "success", 6000)
                mFinTraitementGeneral();
                break;
            case "importstrcon":
                mNotify("Toutes vos données ont été importé dans votre base de données.", "success", 5000);
                if (bddRef.objCptCli.objetMetier.hasDossier() && dataToBeSent.id_dossier) {
                    bddRef.mReloadTable("dossier", function () {
                        bddRef.getObjet("dossier", dataToBeSent.id_dossier).mSaveChamp("dcr")
                        bddRef.getObjet(bddRef.getObjet("dossier", dataToBeSent.id_dossier).data).mShowPopup()
                        mFinImport()
                    })
                } else {
                    mFinImport()
                }
                //bddRef.mReloadTable("structures", function () {
                //    bddRef.mReloadTable("contact", function () {
                //        bddRef.mReloadTable("structures_contact", function () {
                //            if (bddRef.objCptCli.objetMetier.hasDossier() && dataToBeSent.id_dossier) {
                //                bddRef.mReloadTable("dossier", function () {
                //                    bddRef.getObjet("dossier", dataToBeSent.id_dossier).mSaveChamp("dcr")
                //                    bddRef.getObjet(bddRef.getObjet("dossier", dataToBeSent.id_dossier).data).mShowPopup()
                //                    mFinImport()
                //                })
                //            } else {
                //                mFinImport()
                //            }
                //        })
                //    })
                //})

                function mFinImport() {
                    //on ferme le wizard d'importstrcon si on en un
                    var lst = $("body").find(".dx-ctrlimportstrcon")
                    for (var i = 0; i < lst.length; i++) {
                        $(lst[i]).getInstance().element().remove()
                    }
                    var lst = $("body").find(".dx-ctrlwizard")
                    for (var i = 0; i < lst.length; i++) {
                        $(lst[i]).getInstance().element().remove()
                    }
                    var lstTable = []
                    bddRef.vue_table.forEach(function (tab) { lstTable.push(tab.id_table) })
                    mFinTraitementGeneral()
                }
                break;
        }
        hasTraitementBloquantEnCours = false
    }

    function mFinTraitementGeneral() {
        jaugeDemarrage.mHide()
        switch (dataToBeSent.nom_type_traitement) {
            case "restaurationcorbeille":
                var lst = $("body").find(".dx-ctrlgridcorbeille")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().mReloadData != 'undefined') $(lst[i]).getInstance().mReloadData()
                }
                var lst = $("body").find(".dx-dxctrltreeviewdossier")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().reloadDataSource != 'undefined') $(lst[i]).getInstance().reloadDataSource()
                }
                var lst = $("body").find(".dx-ctrlvirtualgrid")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().mReloadData != 'undefined') $(lst[i]).getInstance().mReloadData()
                }
                break;
            case "deletedefinitivementfromhistorique":
                var lst = $("body").find(".dx-ctrlgridcorbeille")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().mReloadData != 'undefined') $(lst[i]).getInstance().mReloadData()
                }
                break;
            case "deldanscorbeillelot":
                var lst = $("body").find(".dx-ctrlvirtualgridfixedawsmtotal")
                for (var i = 0; i < lst.length; i++) {
                    $(lst[i]).getInstance().mMajData()
                }
                var lst = $("body").find(".dx-dxctrltreeviewdossier")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().reloadDataSource != 'undefined') $(lst[i]).getInstance().reloadDataSource()
                }
                var lst = $("body").find(".dx-ctrlvirtualgrid")
                for (var i = 0; i < lst.length; i++) {
                    if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().mReloadData != 'undefined') $(lst[i]).getInstance().mReloadData()
                }
                break;
            case "importstrcon":
                var lst = $("body").find(".dx-dxctrltreeviewdossier")
                for (var i = 0; i < lst.length; i++) {
                    $(lst[i]).getInstance().reloadDataSource()
                }
                var lst = $("body").find(".dx-ctrlvirtualgrid")
                for (var i = 0; i < lst.length; i++) {
                    try {
                        if (typeof $(lst[i]).getInstance != 'undefined' && typeof $(lst[i]).getInstance().mReloadData != 'undefined') $(lst[i]).getInstance().mReloadData()
                    } catch (e) {
                        mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                    }
                }
                if (option && option.callBack) option.callBack()
                break;
        }
        if (typeof option != 'undefined' && typeof option.onFinTraitement != 'undefined') option.onFinTraitement()
        hasTraitementBloquantEnCours = false
    }

    //this.mVerifSiTraitement = function () {
    //    mExecute()
    //}

    mExecute()

}